/**
 * External dependencies
 */
import clsx from 'clsx';

/**
 * WordPress dependencies
 */
import { _x, isRTL } from '@safe-wordpress/i18n';
import { textHorizontal, textVertical } from '@safe-wordpress/icons';
import {
	ToggleGroupControl,
	ToggleGroupControlOptionIcon,
} from '@safe-wordpress/components';

const WRITING_MODES = [
	{
		label: _x( 'Horizontal', 'text', 'nelio-ab-testing' ),
		value: 'horizontal-tb',
		icon: textHorizontal,
	},
	{
		label: _x( 'Vertical', 'text', 'nelio-ab-testing' ),
		value: isRTL() ? 'vertical-lr' : 'vertical-rl',
		icon: textVertical,
	},
];

/**
 * Control to facilitate writing mode selections.
 *
 * @param {Object}   props           Component props.
 * @param {string}   props.className Class name to add to the control.
 * @param {string}   props.value     Currently selected writing mode.
 * @param {Function} props.onChange  Handles change in the writing mode selection.
 *
 * @return {Element} Writing Mode control.
 */
type WritingModeControlProps = {
	readonly className?: string;
	readonly value?: string;
	readonly onChange: ( value?: string | number ) => void;
	readonly disabled?: boolean;
};
export function WritingModeControl( {
	className,
	value,
	disabled,
	onChange,
}: WritingModeControlProps ): JSX.Element {
	return (
		<ToggleGroupControl
			isDeselectable
			__nextHasNoMarginBottom
			__next40pxDefaultSize
			label={ _x( 'Orientation', 'text', 'nelio-ab-testing' ) }
			className={ clsx( 'block-editor-writing-mode-control', className ) }
			value={ value }
			onChange={ ( newValue ) => {
				onChange( newValue === value ? undefined : newValue );
			} }
		>
			{ WRITING_MODES.map( ( option ) => {
				return (
					<ToggleGroupControlOptionIcon
						key={ option.value }
						value={ option.value }
						icon={ option.icon }
						label={ option.label }
						disabled={ disabled }
					/>
				);
			} ) }
		</ToggleGroupControl>
	);
}
